export default "__VITE_ASSET__Crp1$Y6s__"